import { useState, useEffect } from "react";
import image1 from './assets/ananya.jpeg'
import image3 from './assets/rajesh.jpeg'
import image4 from './assets/image4.jpg'
import image2 from './assets/avni.jpeg'
import arrow from './assets/arrow.png'
export default function TestimonialSlider() {
  
  const testimonials = [
  {
    id: 1,
    name: "Malti",
    designation: "COO, MK engineering",
    image: image1,
    content: `Our digital transformation journey accelerated rapidly after adopting this platform. 
It integrates seamlessly across departments and enables data-driven decision-making. 
The AI-powered insights have improved our operational efficiency and innovation speed.`
  },
  {
    id: 2,
    name: "Abani Datta",
    designation: "Project Manager, JMBAXI",
    image: image2,
    content: `This platform has streamlined our end-to-end business processes. 
From team coordination to project delivery, everything runs more smoothly. 
We’ve significantly reduced manual errors and improved turnaround times.`
  },
  {
    id: 3,
    name: "Rajesh Kumar",
    designation: "Technology Head, TNDPC",
    image: image3,
    content: `As a GM overseeing multiple units, I appreciate how this system brings visibility and control. 
It keeps my teams aligned with clear KPIs and real-time progress tracking. 
We’ve seen a 30% improvement in project delivery consistency.`
  },
  {
    id: 4,
    name: "Soraya Khan",
    designation: "SR ,Isazi Consulting",
    image: image4,
    content: `Our organization has scaled effortlessly thanks to this platform. 
It provides the transparency and insights we need to make confident business decisions. 
The automation features have freed up valuable time for strategic innovation.`
  }
];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [prevIndex, setPrevIndex] = useState(null);
  const [isAnimating, setIsAnimating] = useState(false);

  const handleNext = () => {
    setPrevIndex(currentIndex);
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
    setIsAnimating(true);
    setTimeout(() => setIsAnimating(false), 500); 
  };

  useEffect(() => {
    const interval = setInterval(handleNext, 5000);
    return () => clearInterval(interval);
  }, [currentIndex]);

  return (
  <section
  className="pt-4 pb-4"
  style={{
    color: "black",
    display: "flex",
    alignItems: "center",
    position: "relative",
    overflow: "hidden",
    height: "250px", 
  }}
>
  <div className="slider-wrapper" style={{ height: "100%", backgroundColor: "#f3f4fc", color: "black" }}>
    {prevIndex !== null && isAnimating && (
      <div className="testimonial-card slide-out">
        <CardContent testimonial={testimonials[prevIndex]} />
      </div>
    )}
    <div className={`testimonial-card ${isAnimating ? "slide-in" : ""}`}>
      <CardContent testimonial={testimonials[currentIndex]} />
    </div>
  </div>

  <button className="icon-circle" onClick={handleNext}>
   <img src={arrow} alt="" width="15px" height="15px"/>
  </button>

  <style>{`
    .slider-wrapper {
      position: relative;
      width: 500px;
      height: 100%; /* match parent height */
    }
.icon-circle {
  background-color: white; 
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 10px;
  height: 10px;
  z-index: 10;
  border: none;
  margin-left: -10px;
}
    .testimonial-card {
      position: absolute;
      width: 100%;
      height: 100%;
      box-shadow: 0 4px 25px rgba(255, 254, 254, 0.9);
      padding: 16px;
      border-radius: 12px;
      backdrop-filter: blur(6px);
      text-align: left;
      top: 0;
      left: 0;
      display: flex;
      flex-direction: column;
      justify-content: center; /* vertically center content */
    }

    .slide-in {
      animation: slideIn 0.5s forwards;
    }

    .slide-out {
      animation: slideOut 0.5s forwards;
    }

    @keyframes slideIn {
      from { transform: translateX(100%); opacity: 0; }
      to { transform: translateX(0); opacity: 1; }
    }

    @keyframes slideOut {
      from { transform: translateX(0); opacity: 1; }
      to { transform: translateX(-100%); opacity: 0; }
    }

  
  `}</style>
</section>

  );
}

function CardContent({ testimonial }) {
  return (
    <div>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "10px" }}>
        <div>
          <p style={{ margin: 0 }}>{testimonial.name}</p>
          <small style={{ color: "black" }}>{testimonial.designation}</small>
        </div>
        <img
          src={testimonial.image}
          alt={testimonial.name}
          style={{
            width: "50px",
            height: "50px",
            borderRadius: "50%",
            objectFit: "cover",
            border: "2px solid #25024f"
          }}
        />
      </div>
      <p style={{ fontStyle: "italic", color: "black", textAlign: "justify" }}>
        “{testimonial.content}”
      </p>
    </div>
  );
}
